import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginCodeVerificationMutationRequest,
  PostApiLoginCodeVerificationMutationResponse,
} from "../../../types/PostApiLoginCodeVerification";

export function getPostApiLoginCodeVerificationUrl() {
  return `/api/Login/code-verification` as const;
}

/**
 * {@link /api/Login/code-verification}
 */
export async function postApiLoginCodeVerification(
  data?: PostApiLoginCodeVerificationMutationRequest,
  config: Partial<
    RequestConfig<PostApiLoginCodeVerificationMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginCodeVerificationMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginCodeVerificationMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginCodeVerificationUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
